import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-pinned-dashboard',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './pinned-dashboard.component.html',
  styleUrls: ['./pinned-dashboard.component.scss']
})
export class PinnedDashboardComponent implements OnInit {
  @Input() title: string = "No Title";
  @Input() cssClass: string = "";

  constructor() { }

  ngOnInit(): void {
  }

}
